export default __webpack_public_path__ + "static/17-74d46b8905b2edc2c35284de02926d31.gif";